// @flow
import React from 'react'

import styles from './styles'

type Props = {
  bodyText?: string,
  cancelButtonText?: string,
  confirmButtonText?: string,
  headerText?: string,
  onCancel: Function,
  onConfirm?: Function,
  disabled?: boolean,
}

const Dialog = ({
  bodyText = null,
  cancelButtonText = null,
  confirmButtonText = 'OK',
  headerText = null,
  onCancel,
  onConfirm = null,
  disabled = false,
}: Props) => {
  const close = () => onCancel

  const reff = React.useRef(null)

  React.useEffect(() => {
    if (reff.current) {
      let currentElement = reff.current
      let levelCount = 0
      const maxLevels = 5

      while (currentElement.parentElement && levelCount < maxLevels) {
        const parent = currentElement.parentElement

        if (parent.className.includes('modal')) {
          parent.style.backgroundColor = 'transparent'
          parent.style.background = 'transparent'
          parent.style.boxShadow = 'none'
        }

        currentElement = parent
        levelCount++
      }
    }
  }, [])

  const renderCancelButton = () => (
    <button className={styles.cancel} onClick={close()}>
      {cancelButtonText}
    </button>
  )

  const renderConfirmButton = () => (
    <button className={styles.confirm} onClick={onConfirm} disabled={disabled}>
      {confirmButtonText}
    </button>
  )

  const renderHeader = () => <h5 className={styles.header}>{headerText}</h5>

  const renderBodyText = () => <div className={styles.bodyText}>{bodyText}</div>

  return (
    <div className={styles.dialogContainer} ref={reff}>
      <div className={styles.overlay} onClick={close()}></div>
      <section className={styles.dialog}>
        <div className={styles.section}>
          {headerText && renderHeader()}
          {bodyText && renderBodyText()}
        </div>
        <div className={styles.dialogButtons}>
          {cancelButtonText && renderCancelButton()}
          {onConfirm && renderConfirmButton()}
        </div>
      </section>
    </div>
  )
}

Dialog.defaultProps = {
  bodyText: null,
  cancelButtonText: null,
  confirmButtonText: 'OK',
  headerText: null,
  onConfirm: null,
}

export default Dialog
